import * as React from 'react';
/**
 * Хук, позволяющий вызывать эффект только на обновление зависимостей
 * Т.е. эффект не сработает при монтировании
 *
 * @export
 * @param {React.EffectCallback} effect
 * @param {React.DependencyList} deps
 * @param {TUseEffect} [useEffect=React.useEffect]
 */
export function useUpdateEffect(effect, deps) {
  let useEffect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : React.useEffect;
  const mountedRef = React.useRef(false);
  useEffect(() => {
    if (mountedRef.current) {
      return effect();
    } else {
      mountedRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}